<template>
  <div ref="wrapRef" class="wrap" :style="wrapStyle">
    <div class="info">
      <van-icon ref="node" class-prefix="fda-icon" name="success" size="13.86667vw" />
      <div class="title">{{ title }}</div>
      <div v-if="desc" class="desc">{{ desc }}</div>
    </div>
    <div class="action">
      <van-button v-if="btnText" type="primary" block @click="clickBtn">{{ btnText }}</van-button>
      <div v-if="seconds" class="counter">
        <van-count-down :time="time" @finish="clickBtn">
          <template #default="timeData">
            <span class="seconds">{{ timeData.seconds }}</span>
          </template>
        </van-count-down>
        秒后自动跳转
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useElementBounding } from '@vueuse/core';

document.body.scrollTop = 0;
const wrapRef = ref(null);
const { top } = useElementBounding(wrapRef);
const wrapStyle = computed(() => ({
  minHeight: `calc(100vh - ${top.value ?? 0}px - env(safe-area-inset-bottom))`,
}));

interface ResultProps {
  title: string;
  desc?: string;
  btnText?: string;
  seconds?: number;
  click?: Function;
}
const props = withDefaults(defineProps<ResultProps>(), {
  title: '成功',
  desc: undefined,
  btnText: undefined,
  seconds: undefined,
  click: () => {},
});

const time = ref((props.seconds ?? 0) * 1000);
const clickBtn = () => {
  if (props.click) props.click();
  return;
};
</script>
<style lang="less" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  padding-top: 150px;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: #fff;

  &::after {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: env(safe-area-inset-bottom);
    background: #fff;
    content: ' ';
  }
}

.info {
  text-align: center;

  .fda-icon-success {
    color: var(--fda-green-color);
  }

  .title {
    margin-top: 32px;
    line-height: 60px;
    font-weight: 500;
    font-size: 40px;
    color: var(--fda-gray-color-900);
  }

  .desc {
    margin-top: 20px;
    line-height: 48px;
    font-size: 32px;
    color: var(--fda-gray-color-500);
  }
}

.action {
  margin-top: 150px;
  padding: 0 56px;

  .counter {
    display: flex;
    justify-content: center;
    margin-top: 28px;
    width: 100%;
    line-height: 48px;
    font-size: 32px;
    color: var(--fda-gray-color-500);

    .seconds {
      line-height: 48px;
      font-size: 32px;
      color: var(--fda-gray-color-500);
    }
  }
}
</style>
